module.exports = __webpack_public_path__ + "static/media/thumbs_captura-de-pantalla-2012-08-22-a-las-10-15-53.dbd24a05.png";